const CLERK_OAUTH_CONSENT_PATH = "/oauth-consent"

function readClerkAccountsPortalOrigin(): string | null {
  const publishableKey = process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY
  if (
    !publishableKey?.startsWith("pk_live_") &&
    !publishableKey?.startsWith("pk_test_")
  ) {
    return null
  }

  try {
    const encodedFrontendApi = publishableKey.split("_")[2]
    const decodedFrontendApi = atob(encodedFrontendApi)
    if (!decodedFrontendApi.endsWith("$")) {
      return null
    }

    const frontendApi = decodedFrontendApi.slice(0, -1)
    const accountsHost = frontendApi.startsWith("clerk.")
      ? `accounts.${frontendApi.slice("clerk.".length)}`
      : frontendApi.replace(".clerk.accounts.", ".accounts.")

    if (accountsHost === frontendApi) {
      return null
    }

    const accountsUrl = new URL(`https://${accountsHost}`)
    if (
      accountsUrl.hostname !== accountsHost ||
      accountsUrl.pathname !== "/" ||
      accountsUrl.port
    ) {
      return null
    }

    return accountsUrl.origin
  } catch {
    return null
  }
}

export function readSigninRedirectUrl(value: unknown): string {
  if (typeof value !== "string") {
    return "/home"
  }

  try {
    if (value.startsWith("/") && !value.startsWith("//")) {
      const url = new URL(value, "https://coval.invalid")
      if (
        url.origin !== "https://coval.invalid" ||
        !url.pathname.startsWith("/") ||
        url.pathname.startsWith("//")
      ) {
        return "/home"
      }
      return `${url.pathname}${url.search}${url.hash}`
    }

    const accountsOrigin = readClerkAccountsPortalOrigin()
    const url = new URL(value)
    if (
      accountsOrigin &&
      url.protocol === "https:" &&
      url.origin === accountsOrigin &&
      !url.username &&
      !url.password &&
      url.pathname === CLERK_OAUTH_CONSENT_PATH
    ) {
      return `${accountsOrigin}${CLERK_OAUTH_CONSENT_PATH}${url.search}${url.hash}`
    }
  } catch {
    // Invalid and untrusted redirect values fall back to the app home page.
  }

  return "/home"
}
